import { Component, Input, OnInit } from '@angular/core';
import { icons } from 'src/app/Utility/assets';

@Component({
	selector: 'app-trend-arrow',
	template: ` <img *ngIf="number1 || number2" [src]="direction === 'up' ? arrowUpSrc : arrowDownSrc" class="arrow" [ngClass]="{ static: !absolute }" /> `,
	styles: [
		`
			.arrow {
				position: absolute;
				height: 10px;
				width: 10px;
				right: -5px;
				top: 50%;
				transform: translateY(-50%);

				&.static {
					position: static;
					height: auto;
				}
			}
		`,
	],
})
export class TrendArrowComponent implements OnInit {
	@Input() absolute = false;
	@Input() number1: number;
	@Input() number2: number;

	direction: 'up' | 'down' = 'up';

	arrowUpSrc = icons['arrow-up'];
	arrowDownSrc = icons['arrow-down'];

	constructor() {}

	ngOnInit(): void {
		this.direction = this.number1 > this.number2 ? 'up' : 'down';
	}
}
